import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withModifiers as _withModifiers, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5ffbdf67"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "hoverWrapper" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = ["checked"]
const _hoisted_4 = ["checked"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["mapswitch", { map3D: _ctx.current23D === 3 }]),
    onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.toggle23D && _ctx.toggle23D(...args)))
  }, [
    _createElementVNode("div", _hoisted_1, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.baseLayerList, (layer) => {
        return (_openBlock(), _createElementBlock("div", {
          class: _normalizeClass(["item", { current: _ctx.currentBaseLayerID === layer.id }]),
          key: layer.id,
          onClick: _withModifiers(($event: any) => (_ctx.toggleBaselayer(layer)), ["stop"]),
          style: _normalizeStyle({ background: 'url(' + layer.thumbnail + ') no-repeat' })
        }, null, 14, _hoisted_2))
      }), 128)),
      ((_ctx.currentBaseLayer && _ctx.currentBaseLayer.annotion) || _ctx.current23D === 3
        )
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "checksWrapper",
            onClick: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["stop"]))
          }, [
            (_ctx.currentBaseLayer && _ctx.currentBaseLayer.annotion)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.annotionChecked = !_ctx.annotionChecked), ["stop"])),
                  style: {"margin-right":"10px"}
                }, [
                  _createElementVNode("input", {
                    type: "checkbox",
                    checked: _ctx.annotionChecked
                  }, null, 8, _hoisted_3),
                  _createTextVNode(" " + _toDisplayString(_ctx.$t('NavigationBar.annotation')), 1)
                ]))
              : _createCommentVNode("", true),
            (_ctx.current23D === 3)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 1,
                  onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.demChecked = !_ctx.demChecked), ["stop"]))
                }, [
                  _createElementVNode("input", {
                    type: "checkbox",
                    checked: _ctx.demChecked
                  }, null, 8, _hoisted_4),
                  _createTextVNode(" " + _toDisplayString(_ctx.$t('NavigationBar.dem')), 1)
                ]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true)
    ])
  ], 2))
}